import React from 'react';
import ResultsGrid from '../components/ResultsGrid';
import ResultsTile from '../components/ResultsTile';
import { getMatchStatusFromRow } from '../services/colorService';

// Real extraction data from your successful run
const realExtractionData = {
  "success": true,
  "extraction_result": {
    "success": true,
    "extracted_fields": {
      "Contract Date": {
        "value": "March 31, 2023",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "2023-03-31 00:00:00",
        "system_document_match": "PERFECT_MATCH",
        "comment": "Algorithmic match: Date match (timestamps ignored)"
      },
      "Borrower Name": {
        "value": "Bessa Brothers, Inc.",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Bessa Brothers, Inc.",
        "system_document_match": "PERFECT_MATCH",
        "comment": "Algorithmic match: Exact string match"
      },
      "Default rate of interest": {
        "value": "6.000 percentage point margin",
        "page": 2,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Demand": {
        "value": "On Demand",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Y",
        "system_document_match": "MAYBE_MATCH",
        "comment": "LLM match: The core system value 'Y' likely represents 'Yes' or 'On Demand', which is similar to the document value 'On Demand'"
      },
      "Interest Rate Index Source": {
        "value": "The Wall Street Journal Prime Rate as published by the Wall Street Journal",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Interest Rate Margin": {
        "value": "1.500 percentage points over the Index",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "0.015",
        "system_document_match": "MAYBE_MATCH",
        "comment": "LLM match: The core system value '0.015' represents a 1.5% interest rate margin, which is similar to the document value '1.500 percentage points over the Index'"
      },
      "Maturity Date": {
        "value": "On Demand",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "2099-01-01 00:00:00",
        "system_document_match": "NO_MATCH",
        "comment": "LLM match: The core system value represents a specific date, while the document value is 'On Demand', which does not represent a specific date"
      },
      "Max Rate": {
        "value": "the maximum rate allowed by applicable law",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "0.18",
        "system_document_match": "MAYBE_MATCH",
        "comment": "LLM match: The core system value '0.18' represents an 18% maximum rate, which is similar to the document value 'the maximum rate allowed by applicable law'"
      },
      "Min Rate": {
        "value": "7.750% per annum",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "0.0775",
        "system_document_match": "MAYBE_MATCH",
        "comment": "LLM match: The core system value '0.0775' represents a 7.75% minimum rate, which is similar to the document value '7.750% per annum'"
      },
      "Original Loan Amount or original Principal Balance": {
        "value": "$150,000.00",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "150,000.00",
        "system_document_match": "PERFECT_MATCH",
        "comment": "Algorithmic match: Numeric match (within 1% tolerance)"
      },
      "Payment": {
        "value": "Borrower will pay regular monthly payments of all accrued unpaid interest due as of each payment date, beginning April 30, 2023, with all subsequent interest payments to be due on the same day of each month after that.",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Not Found",
        "system_document_match": "NO_MATCH",
        "comment": "Core system value not found. Algorithmic match: Partial string match"
      },
      "Rate": {
        "value": "1.500 percentage points over the Index",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Rate Change Frequency": {
        "value": "each Day",
        "page": 1,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Revolving Line": {
        "value": "This Note evidences a revolving line of credit.",
        "page": 2,
        "source": "note_2023_03_31",
        "document_date": "2023-03-31",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Amortization": {
        "value": "N/A",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Asset Based Lending": {
        "value": "Yes",
        "page": 1,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Collateral Lien Position": {
        "value": "1st position",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Collateral Value": {
        "value": "$729,711",
        "page": 5,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Date Last Reviewed": {
        "value": "New",
        "page": 1,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "2023-03-14",
        "system_document_match": "NO_MATCH",
        "comment": "LLM match: The core system value represents a date, while the document value is 'New', which does not represent a date"
      },
      "Debt Service Coverage": {
        "value": "2.59x",
        "page": 4,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Debt Service Coverage Ratio": {
        "value": "2.59x",
        "page": 4,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "FDIC Code": {
        "value": "Comm & Industrial/US",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "CIUS",
        "system_document_match": "MAYBE_MATCH",
        "comment": "LLM match: The core system value 'CIUS' is likely an abbreviation for 'Comm & Industrial/US', which is similar to the document value"
      },
      "Loan Fees": {
        "value": "$250",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "High Volatility Commercial Real Estate": {
        "value": "No",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Loan to Value Ratio": {
        "value": "4.86x",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "MB Exception": {
        "value": "No",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Y",
        "system_document_match": "NO_MATCH",
        "comment": "LLM match: The core system value 'Y' likely represents 'Yes', while the document value 'No' is clearly different"
      },
      "NAICS Code": {
        "value": "238131 - Residential Framing Contractors",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "238130",
        "system_document_match": "MAYBE_MATCH",
        "comment": "LLM match: The core system value '238130' is likely a NAICS code, which is similar to the document value '238131 - Residential Framing Contractors'"
      },
      "Net Operating Income EBITDA": {
        "value": "$1,052,283",
        "page": 3,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Original Term": {
        "value": "Demand",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "480.434067740875",
        "system_document_match": "NO_MATCH",
        "comment": "LLM match: The core system value '480.434067740875' represents a numeric term, while the document value 'Demand' does not represent a specific term"
      },
      "Prepayment Penalty Term": {
        "value": "N/A",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Property Collateral Code": {
        "value": "Comm & Industrial/US",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      },
      "Risk Rating": {
        "value": "3A",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "GOOD",
        "system_document_match": "MAYBE_MATCH",
        "comment": "LLM match: The values 'GOOD' and '3A' may represent the same risk rating, but the mapping is not clear without additional context"
      },
      "Roles; Guarantor %": {
        "value": "Fernando Alves (60%), Marcelo Alves (40%)",
        "page": 2,
        "source": "proposal_2023_03_24",
        "document_date": "2023-03-24",
        "core_data_value": "Not Found",
        "master_value": "Not Found"
      }
    },
    "total_fields_found": 33,
    "documents_processed": 3
  },
  "match_result": {
    "Contract Date": {
      "value": "March 31, 2023",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "2023-03-31 00:00:00",
      "system_document_match": "PERFECT_MATCH",
      "comment": "Algorithmic match: Date match (timestamps ignored)"
    },
    "Borrower Name": {
      "value": "Bessa Brothers, Inc.",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Bessa Brothers, Inc.",
      "system_document_match": "PERFECT_MATCH",
      "comment": "Algorithmic match: Exact string match"
    },
    "Default rate of interest": {
      "value": "6.000 percentage point margin",
      "page": 2,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Demand": {
      "value": "On Demand",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Y",
      "system_document_match": "MAYBE_MATCH",
      "comment": "LLM match: The core system value 'Y' likely represents 'Yes' or 'On Demand', which is similar to the document value 'On Demand'"
    },
    "Interest Rate Index Source": {
      "value": "The Wall Street Journal Prime Rate as published by the Wall Street Journal",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Interest Rate Margin": {
      "value": "1.500 percentage points over the Index",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "0.015",
      "system_document_match": "MAYBE_MATCH",
      "comment": "LLM match: The core system value '0.015' represents a 1.5% interest rate margin, which is similar to the document value '1.500 percentage points over the Index'"
    },
    "Maturity Date": {
      "value": "On Demand",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "2099-01-01 00:00:00",
      "system_document_match": "NO_MATCH",
      "comment": "LLM match: The core system value represents a specific date, while the document value is 'On Demand', which does not represent a specific date"
    },
    "Max Rate": {
      "value": "the maximum rate allowed by applicable law",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "0.18",
      "system_document_match": "MAYBE_MATCH",
      "comment": "LLM match: The core system value '0.18' represents an 18% maximum rate, which is similar to the document value 'the maximum rate allowed by applicable law'"
    },
    "Min Rate": {
      "value": "7.750% per annum",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "0.0775",
      "system_document_match": "MAYBE_MATCH",
      "comment": "LLM match: The core system value '0.0775' represents a 7.75% minimum rate, which is similar to the document value '7.750% per annum'"
    },
    "Original Loan Amount or original Principal Balance": {
      "value": "$150,000.00",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "150,000.00",
      "system_document_match": "PERFECT_MATCH",
      "comment": "Algorithmic match: Numeric match (within 1% tolerance)"
    },
    "Payment": {
      "value": "Borrower will pay regular monthly payments of all accrued unpaid interest due as of each payment date, beginning April 30, 2023, with all subsequent interest payments to be due on the same day of each month after that.",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Not Found",
      "system_document_match": "NO_MATCH",
      "comment": "Core system value not found. Algorithmic match: Partial string match"
    },
    "Rate": {
      "value": "1.500 percentage points over the Index",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Rate Change Frequency": {
      "value": "each Day",
      "page": 1,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Revolving Line": {
      "value": "This Note evidences a revolving line of credit.",
      "page": 2,
      "source": "note_2023_03_31",
      "document_date": "2023-03-31",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Amortization": {
      "value": "N/A",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Asset Based Lending": {
      "value": "Yes",
      "page": 1,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Collateral Lien Position": {
      "value": "1st position",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Collateral Value": {
      "value": "$729,711",
      "page": 5,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Date Last Reviewed": {
      "value": "New",
      "page": 1,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "2023-03-14",
      "system_document_match": "NO_MATCH",
      "comment": "LLM match: The core system value represents a date, while the document value is 'New', which does not represent a date"
    },
    "Debt Service Coverage": {
      "value": "2.59x",
      "page": 4,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Debt Service Coverage Ratio": {
      "value": "2.59x",
      "page": 4,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "FDIC Code": {
      "value": "Comm & Industrial/US",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "CIUS",
      "system_document_match": "MAYBE_MATCH",
      "comment": "LLM match: The core system value 'CIUS' is likely an abbreviation for 'Comm & Industrial/US', which is similar to the document value"
    },
    "Loan Fees": {
      "value": "$250",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "High Volatility Commercial Real Estate": {
      "value": "No",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Loan to Value Ratio": {
      "value": "4.86x",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "MB Exception": {
      "value": "No",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Y",
      "system_document_match": "NO_MATCH",
      "comment": "LLM match: The core system value 'Y' likely represents 'Yes', while the document value 'No' is clearly different"
    },
    "NAICS Code": {
      "value": "238131 - Residential Framing Contractors",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "238130",
      "system_document_match": "MAYBE_MATCH",
      "comment": "LLM match: The core system value '238130' is likely a NAICS code, which is similar to the document value '238131 - Residential Framing Contractors'"
    },
    "Net Operating Income EBITDA": {
      "value": "$1,052,283",
      "page": 3,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Original Term": {
      "value": "Demand",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "480.434067740875",
      "system_document_match": "NO_MATCH",
      "comment": "LLM match: The core system value '480.434067740875' represents a numeric term, while the document value 'Demand' does not represent a specific term"
    },
    "Prepayment Penalty Term": {
      "value": "N/A",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Property Collateral Code": {
      "value": "Comm & Industrial/US",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    },
    "Risk Rating": {
      "value": "3A",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "GOOD",
      "system_document_match": "MAYBE_MATCH",
      "comment": "LLM match: The values 'GOOD' and '3A' may represent the same risk rating, but the mapping is not clear without additional context"
    },
    "Roles; Guarantor %": {
      "value": "Fernando Alves (60%), Marcelo Alves (40%)",
      "page": 2,
      "source": "proposal_2023_03_24",
      "document_date": "2023-03-24",
      "core_data_value": "Not Found",
      "master_value": "Not Found"
    }
  },
  "analysis": {
    "total_fields": 44,
    "perfect_matches": 3,
    "maybe_matches": 7,
    "no_matches": 34,
    "total_found": 39,
    "match_success_rate": 6.8181818181818175,
    "fields_found_rate": 88.63636363636364
  },
  "loan_id": "1048175805",
  "documents_processed": [
    "guaranty_2023_03_31",
    "note_2023_03_31",
    "proposal_2023_03_24"
  ],
  "preview_mode": true,
  "save_result": null
};

// Create test data with some null fields to simulate the errors
const testDataWithNulls = {
  ...realExtractionData,
  match_result: {
    ...realExtractionData.match_result,
    // Add some null entries to test error handling
    "Null Field Test": null,
    "Another Null Test": null
  }
};

const ResultsTest = () => {
  console.log('🧪 Testing ResultsGrid with real data...');
  console.log('📊 Real extraction data:', realExtractionData);
  console.log('❌ Test data with nulls:', testDataWithNulls);

  return (
    <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>🧪 Frontend Components Test</h1>
      <p>Testing with real extraction data to identify all frontend errors at once.</p>
      
      <div style={{ marginBottom: '3rem' }}>
        <h2>✅ ResultsGrid with Valid Data</h2>
        <div style={{ border: '2px solid green', padding: '1rem', borderRadius: '8px' }}>
          <ResultsGrid 
            results={realExtractionData.match_result}
            overrides={{}}
          />
        </div>
      </div>

      <div style={{ marginBottom: '3rem' }}>
        <h2>❌ ResultsGrid with Null Data (Should Show Errors)</h2>
        <div style={{ border: '2px solid red', padding: '1rem', borderRadius: '8px' }}>
          <ResultsGrid 
            results={testDataWithNulls.match_result}
            overrides={{}}
          />
        </div>
      </div>

      <div style={{ marginBottom: '3rem' }}>
        <h2>🧪 Individual ResultsTile Tests</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1rem' }}>
          {/* Test with valid data */}
          <div style={{ border: '1px solid green', padding: '1rem', borderRadius: '8px' }}>
            <h3>Valid Data</h3>
            <ResultsTile 
              fieldName="Contract Date"
              data={realExtractionData.match_result["Contract Date"]}
              overrides={{}}
            />
          </div>

          {/* Test with null data */}
          <div style={{ border: '1px solid red', padding: '1rem', borderRadius: '8px' }}>
            <h3>Null Data</h3>
            <ResultsTile 
              fieldName="Null Field Test"
              data={null}
              overrides={{}}
            />
          </div>

          {/* Test with undefined data */}
          <div style={{ border: '1px solid orange', padding: '1rem', borderRadius: '8px' }}>
            <h3>Undefined Data</h3>
            <ResultsTile 
              fieldName="Undefined Field"
              data={undefined}
              overrides={{}}
            />
          </div>

          {/* Test with missing properties */}
          <div style={{ border: '1px solid blue', padding: '1rem', borderRadius: '8px' }}>
            <h3>Missing Properties</h3>
            <ResultsTile 
              fieldName="Incomplete Field"
              data={{ value: "Test Value" }} // Missing other properties
              overrides={{}}
            />
          </div>
        </div>
      </div>

      <div style={{ marginTop: '2rem', padding: '1rem', backgroundColor: '#f5f5f5', borderRadius: '8px' }}>
        <h3>🔍 Debug Information</h3>
        <p><strong>Total fields in match_result:</strong> {Object.keys(realExtractionData.match_result).length}</p>
        <p><strong>Fields with system_document_match:</strong> {
          Object.values(realExtractionData.match_result).filter(field => 
            field && field.system_document_match
          ).length
        }</p>
        <p><strong>Perfect matches:</strong> {
          Object.values(realExtractionData.match_result).filter(field => 
            field && field.system_document_match === 'PERFECT_MATCH'
          ).length
        }</p>
        <p><strong>Maybe matches:</strong> {
          Object.values(realExtractionData.match_result).filter(field => 
            field && field.system_document_match === 'MAYBE_MATCH'
          ).length
        }</p>
        <p><strong>No matches:</strong> {
          Object.values(realExtractionData.match_result).filter(field => 
            field && field.system_document_match === 'NO_MATCH'
          ).length
        }</p>
      </div>
    </div>
  );
};

export default ResultsTest;
